const Icon1 = () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7563_37978)">
            <path
                d="M11.6457 1.75269H5.06502C4.74434 1.75269 4.48438 2.01265 4.48438 2.33333V13.7527C4.48438 14.0734 4.74434 14.3333 5.06502 14.3333H11.6457C11.9663 14.3333 12.2263 14.0734 12.2263 13.7527V2.33333C12.2263 2.01265 11.9663 1.75269 11.6457 1.75269Z"
                stroke="white"
                strokeWidth="0.580645"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M4.48438 7.0752L12.2263 7.0752" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.93555 4.17188L5.93555 5.62349" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.93555 8.52686L5.93555 9.97847" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_7563_37978">
                <rect width="15.4839" height="15.4839" fill="white" transform="translate(0.613281 0.301025)" />
            </clipPath>
        </defs>
    </svg>
);

const Icon2 = () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7563_37979)">
            <path d="M4.91904 8.04297L3.32227 11.9139H13.9674L12.3707 8.04297H4.91904Z" stroke="white" strokeWidth="0.580645" strokeLinejoin="round" />
            <path d="M4.29004 3.20435L4.97552 8.04305" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13 3.20435L12.3145 8.04305" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.64551 2.23657V8.04302" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M3.32227 11.9138V12.9783C3.32227 13.1921 3.49557 13.3654 3.70936 13.3654H13.5803C13.7941 13.3654 13.9674 13.1921 13.9674 12.9783V11.9138"
                stroke="white"
                strokeWidth="0.580645"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_7563_37979">
                <rect width="15.4839" height="15.4839" fill="white" transform="translate(0.90332 0.301025)" />
            </clipPath>
        </defs>
    </svg>
);

const Icon3 = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7563_37980)">
            <path
                d="M10.8398 12.3011L10.8398 3.78499C10.8398 3.46431 10.5799 3.20435 10.2592 3.20435L5.61404 3.20435C5.29336 3.20435 5.03339 3.46431 5.03339 3.78499L5.03339 12.3011C5.03339 12.6218 5.29336 12.8818 5.61404 12.8818L10.2592 12.8818C10.5799 12.8818 10.8398 12.6218 10.8398 12.3011Z"
                stroke="white"
                strokeWidth="0.464516"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11.8076 9.34131V6.67236" stroke="white" strokeWidth="0.464516" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M2.12988 9.34131V6.67236" stroke="white" strokeWidth="0.464516" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M12.7754 10.3848V5.62354" stroke="white" strokeWidth="0.464516" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M3.09766 10.3848V5.62354" stroke="white" strokeWidth="0.464516" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M13.7432 9.44411V6.7229" stroke="white" strokeWidth="0.464516" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M4.06543 9.44411V6.7229" stroke="white" strokeWidth="0.464516" strokeMiterlimit="10" strokeLinecap="round" />
            <circle cx="7.93649" cy="8.04294" r="0.967742" stroke="white" strokeWidth="0.464516" />
            <circle cx="7.93646" cy="8.04291" r="1.93548" stroke="white" strokeWidth="0.464516" />
        </g>
        <defs>
            <clipPath id="clip0_7563_37980">
                <rect width="15.4839" height="15.4839" fill="white" transform="translate(0.194336 0.301025)" />
            </clipPath>
        </defs>
    </svg>
);

const Icon4 = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7563_37981)">
            <path
                d="M13.9355 3.20435H2.51619C2.19551 3.20435 1.93555 3.46431 1.93555 3.78499V10.8495C1.93555 11.1702 2.19551 11.4302 2.51619 11.4302H13.9355C14.2562 11.4302 14.5162 11.1702 14.5162 10.8495V3.78499C14.5162 3.46431 14.2562 3.20435 13.9355 3.20435Z"
                stroke="white"
                strokeWidth="0.580645"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.8716 4.65576H3.58124C3.47435 4.65576 3.3877 4.74242 3.3877 4.84931V9.78479C3.3877 9.89169 3.47435 9.97834 3.58124 9.97834H12.8716C12.9785 9.97834 13.0651 9.89169 13.0651 9.78479V4.84931C13.0651 4.74242 12.9785 4.65576 12.8716 4.65576Z"
                stroke="white"
                strokeWidth="0.580645"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M3.87109 12.7844L4.5969 11.5273" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.8232 12.7844L12.0974 11.5273" stroke="white" strokeWidth="0.580645" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_7563_37981">
                <rect width="15.4839" height="15.4839" fill="white" transform="translate(0.484375 0.301025)" />
            </clipPath>
        </defs>
    </svg>
);

export { Icon1, Icon2, Icon3, Icon4 };
